import { render, staticRenderFns } from "./GamesSection.vue?vue&type=template&id=1dcb43c8&scoped=true"
import script from "./GamesSection.vue?vue&type=script&lang=js"
export * from "./GamesSection.vue?vue&type=script&lang=js"
import style0 from "./GamesSection.vue?vue&type=style&index=0&id=1dcb43c8&prod&lang=scss"
import style1 from "./GamesSection.vue?vue&type=style&index=1&id=1dcb43c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcb43c8",
  null
  
)

export default component.exports